<template>
  <div>
    <div class='titlelist'>
      <div v-for='(v,i) in islang == "eng"?en_list:list' :key='i+"101"' @click='handclick(i)'
        :style="{borderRight:(i+1)<list.length?'1px solid #d8d8d8':'',padding: islang == 'eng'?'0 1rem':'0 1.8rem'}">
        <span :style="{borderBottom:isright==i?'3px solid #09666E':'',color:isright==i?'#09666E':''}">{{v}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['isnum'],
    data() {
      return {
        islang: window.localStorage.guanwanglang,
        list: ['香港證券', '新股認購', '環球證券', '債券服務', '基金服務', '滬深港通', '證券轉倉'], //,'服務收費'
        en_list: ['Hong Kong Securities', 'IPO Subscriptions', 'Global Securities', 'Bond Services', 'Fund Services',
          'Stock Connect', 'Securities Transfer'
        ], //,'Services Fees'
        urllist: ['/hksecurities_introduction', '/ipo_subscriptions', '/ussecurities_introduction', '/bonds_introduction', '/fund_introduction', '/stockconnect_introduction',
        '/securities_transfer'], //,'/services_fee'
        isright: 0,
      }
    },
    watch: {
      isnum: {
        immediate: true,
        handler(ev) {
          this.isright = this.isnum || 0
        },
      },
    },
    mounted() {
      document.documentElement.scrollTop = 0;
      window.console.log(this.$router)
      // javascript:window.history.forward(1);
    },
    methods: {
      handclick(i) {
        this.isright = i
        if (this.urllist[i]) {
          this.$router.push(this.urllist[i])

        }
      },
    }
  }
</script>
<style>
  .look_g {
    position: relative !important;
    left: -14.4px !important;
  }
</style>
<style scoped>
  .titlelist {
    /* display: flex;
    justify-content: space-between; */
    text-align: center;
    font-size: 16px;
    margin-bottom: 1.5rem;
    margin-left: -1rem;
  }

  .titlelist div {
    display: inline-block;

    font-size: 18px;
    color: #000;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/compoents/titlelist.vue